import React from 'react';

const Breadcrumb = ({title, item1, item2, item3, onClick, bgColor, textColor}) => {
  
  return (
    <div className={`flex justify-between items-center mt-4 mb-8 px-10 py-6 ${bgColor} rounded-lg`}>
      <p className={`text-lg font-ManropeBold ${textColor}`}>{title}</p>
      <div className='flex items-center space-x-2'>
        <span
          onClick={onClick}
          className='text-white hover:underline cursor-pointer'>
          {item1}
        </span>
        {item2 && (
          <>
            <span className='text-white text-base'>&gt;</span>
            <span className='text-white font-semibold'>{item2}</span>
          </>
        )}
        {item3 && (
          <>
            <span className='text-white text-base'>&gt;</span>
            <span className='text-white font-semibold'>{item3}</span>
          </>
        )}
      </div>
    </div>
  );
};

export default Breadcrumb;
